import { employerField } from "enums";

export const employerRequiredMsg = (field = "") => {
  return `${employerField[field]?.label ?? 'This field'} is required`;
};
